$(window).on("load", function () {
  // AOS Js
  AOS.init({
    easing: "ease-in-out-sine",
    offset: 10,
    disable: window.innerWidth <= 991
  });
});

$(document).ready(function () {
  $('#slick-reviews').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      }
    },
                 {
                   breakpoint: 480,
                   settings: {
                     slidesToShow: 1,
                   }
                 }]
  });
  $('#slick-features').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      }
    },
                 {
                   breakpoint: 480,
                   settings: {
                     slidesToShow: 1,
                   }
                 }]
  });
  
  /*_____ Video _____*/
  $(document).on("click", ".vidBlk .playBtn", function () {
    sec = $(this).parents("section");
    sec.find(".video_popup").fadeIn();
    src = sec.find(".video_popup iframe").attr("data-src");
    sec.find(".video_popup iframe").attr("src", src);
  });
  $(document).on("click", ".video_popup .crossBtn", function () {
    $(".video_popup iframe").attr("src", "");
    $(".video_popup").fadeOut();
  });
  /*_____ FAQ's _____*/
  $(document).on("click", ".faqBlk > h5", function () {
    $(".faqBlk").not($(this).parent().toggleClass("active")).removeClass("active");
    $(".faqBlk > .txt").not($(this).parent().children(".txt").slideToggle()).slideUp();
  });

  $(".faqLst > .faqBlk:nth-child(1)").addClass("active");
  /*_____ runBtn _____*/
  $(".runBtn").on("click", function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      // console.log(hash);
      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top - 0,
        },
        500
      );
    }
  });
//   $(document).on("click", "#blocks .fig_list > li .fig", function () {
//     src = $(this).find("img").attr("src");
//     price = $(this).find(".cam-price").text();
//     console.log(price);
//     $("#blocks .image > img").attr("src", src);
//     $('.price .amount').html(price);
//   });

  $('.clickme a').click(function(){
    $('.clickme a').removeClass('activelink');
    $(this).addClass('activelink');
    var tagid = $(this).data('tag');
    $('.tab-content-blk').removeClass('active').addClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
  });
  $('.accordion-list > li > .answer').hide();

  $('.accordion-list li').click(function() {
    if ($(this).hasClass("activelink")) {
      $(this).removeClass("activelink").find(".answer").slideUp();
    } else {
      $(".accordion-list > li.activelink .answer").slideUp();
      $(".accordion-list > li.activelink").removeClass("activelink");
      $(this).addClass("activelink").find(".answer").slideDown();
    }
    return false;
  });
  
  
  
  $(document).on("click", ".accordion-list .accordion-list-title", function () {
    $(".accordion-list").not($(this).parent().toggleClass("active")).removeClass("active");
    $(".accordion-list > .answer").not($(this).parent().children(".answer").slideToggle()).slideUp();
  });
  

  $(window).scroll(function(){
    if ($(this).scrollTop() > 250) {
       $('.fixed-bar').addClass('active-fixed');
    } else {
       $('.fixed-bar').removeClass('active-fixed');
    }
});
  
  
  var addClassOnScroll = function () {
            var windowTop = $(window).scrollTop();
            $('div[id]').each(function (index, elem) {
                var offsetTop = $(elem).offset().top;
                var outerHeight = $(this).outerHeight(true);

                if( windowTop > (offsetTop - 50) && windowTop < ( offsetTop + outerHeight)) {
                    var elemId = $(elem).attr('id');
                    $(".accordion-action-wrap ul li a.active").removeClass('active');
                    $(".accordion-action-wrap ul li a[href='#" + elemId + "']").addClass('active');
                }
            });
        };

        $(function () {
            $(window).on('scroll', function () {
                addClassOnScroll();
            });
        });
  
  
});